import { api } from 'services/api/baseBackendAPI';

export const portfolioApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPortfolios: build.query({
      query: () => ({
        url: `fundinvestment-page/get-portfolio-list`,
        method: 'GET',
      }),
      providesTags: ['Portfolio'],
    }),
    getFiscalYears: build.query({
      query: (requestObject) => ({
        url: `fundinvestment-page/get-fiscal-years`,
        method: 'GET',
        params: requestObject,
      }),
      providesTags: (result, error, arg) => [
        { type: 'FiscalYears', id: arg.portfolio_id },
      ],
    }),
    getFundsByStageChart: build.query({
      query: (requestObject) => ({
        url: `fundinvestment-page/get-funds-by-status-chart`,
        method: 'GET',
        params: requestObject,
      }),
      providesTags: ['PortfolioInvestments'],
    }),

    getAssetClassBreakdownChart: build.query({
      query: (requestObject) => ({
        url: `fundinvestment-page/get-asset-class-breakdown-chart`,
        method: 'GET',
        params: requestObject,
      }),
      providesTags: ['PortfolioInvestments'],
    }),

    getPacingTargetPcts: build.query({
      query: (requestObject) => ({
        url: `fundinvestment-page/get-pacing-target-pcts`,
        method: 'GET',
        params: requestObject,
      }),
      providesTags: ['PacingTargetPcts'],
    }),

    getPlanExecutionChart: build.query({
      query: (requestObject) => ({
        url: `fundinvestment-page/get-plan-execution-chart`,
        method: 'GET',
        params: requestObject,
      }),
      providesTags: ['PortfolioInvestments'],
    }),

    getPortfolioInvestments: build.query({
      query: (requestObject) => ({
        url: `fundinvestment-page/get-portfolio-investments`,
        method: 'GET',
        params: requestObject,
      }),
      providesTags: ['PortfolioInvestments'],
    }),
    getHighInterestInvestments: build.query({
      query: (requestObject) => ({
        url: `fundinvestment-page/get-high-interest-investments`,
        method: 'GET',
        params: requestObject,
      }),
      providesTags: ['HighInterestInvestments'],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetPortfoliosQuery,
  useGetFiscalYearsQuery,
  useGetPlanExecutionChartQuery,
  useGetAssetClassBreakdownChartQuery,
  useGetFundsByStageChartQuery,
  useGetPortfolioInvestmentsQuery,
  useGetHighInterestInvestmentsQuery,
  useGetPacingTargetPctsQuery,
} = portfolioApi;
